'use client'

import { Box, Text, useMultiStyleConfig } from '@chakra-ui/react'
import React, { ReactNode } from 'react'
import useIntl from '~/hooks/useIntl/useIntl'

export function SoldOutRibbon() {
  const intl = useIntl()
  const styles = useMultiStyleConfig('FlightAviosOnlyBanner', {})

  const soldOutLabel = intl.formatMessage({
    id: 'avios-only-flight-sold-out',
    defaultMessage: 'Sold out',
  })

  const soldOutLabels = new Array<ReactNode>(10).fill(
    <Text as="span" sx={styles.soldOutRibbonText}>
      {soldOutLabel}
    </Text>
  )
  return (
    <Box sx={styles.soldOutRibbon} data-testid="flight-avios-only-sold-out-ribbon">
      {soldOutLabels}
    </Box>
  )
}
